let _ = t => t,
  _t;
import { createGlobalStyle } from 'styled-components';
import { useIsPillBorderRadius } from '../hooks/useIsPillBorderRadius';

// foundations-components DialogHeader uses theme.borderRadius['0'] for its
// bottom corners. In pill border-radius mode, our theme maps that token to
// 16px instead of 0px (rounded and square modes are unaffected). The bottom
// of the header should always be straight where it meets the dialog body.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGlobalDialogHeaderOverrides = createGlobalStyle(_t || (_t = _`
  ${0}
`), ({
  $isPill
}) => $isPill && `
      [role="dialog"] > header:first-child,
      [role="dialog"] > form > header:first-child {
        border-bottom-left-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
      }
    `);
export const GlobalDialogHeaderStyles = () => {
  const isPill = useIsPillBorderRadius();
  return /*#__PURE__*/_jsx(StyledGlobalDialogHeaderOverrides, {
    $isPill: isPill
  });
};